import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { KibButtonNew } from '@chewy/kib-controls-react'
import { KibTextarea } from '@chewy/kib-fields-new-react'
import type { Field } from '@pbt/pbt-ui-components'

import styles from './OrderItemReceipt.module.scss'

interface OrderItemReceiptNotesProps {
  damageNotesField: Field
  isDamaged: boolean
  isDisabled: boolean
  isDraft: boolean
}

export const OrderItemReceiptNotes = ({
  damageNotesField,
  isDamaged,
  isDisabled,
  isDraft,
}: OrderItemReceiptNotesProps) => {
  const { t } = useTranslation('Common')

  const hasExistingNotes = Boolean(
    damageNotesField.initialValue ?? damageNotesField.value,
  )

  const [isExpanded, setIsExpanded] = useState(hasExistingNotes)

  useEffect(() => {
    if (isDamaged) {
      setIsExpanded(true)
    } else if (!damageNotesField.value) {
      setIsExpanded(false)
    }
  }, [isDamaged, damageNotesField.value])

  if (isDraft) {
    if (isExpanded) {
      return (
        <KibTextarea
          disabled={isDisabled}
          invalid={damageNotesField.errors.length > 0}
          label={damageNotesField.label!}
          messagesContent={damageNotesField.message}
          required={isDamaged}
          value={damageNotesField.value ?? ''}
          onChange={(e) => damageNotesField.setValue(e.target.value)}
        />
      )
    }

    return (
      <KibButtonNew
        className={styles.addNoteLink}
        disabled={isDisabled}
        onClick={() => setIsExpanded(true)}
      >
        {t('Common:ADD_NOTE')}
      </KibButtonNew>
    )
  }

  if (damageNotesField.value) {
    return (
      <div className={styles.notesReadOnly}>
        <span className={styles.notesLabel}>{damageNotesField.label}</span>
        <p className={styles.notesText}>{damageNotesField.value}</p>
      </div>
    )
  }

  return null
}
